import { Directive, input, computed, effect, inject } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
/**
 * Directive to create a tooltip with customizable options.
 * Usage:
 * import { WFSTooltipDirective } from 'Shared/app/directives/wfs-tooltip.directive';
 * Then add it in your template, for example with minimum required options:
 * '<span
 *  wfsTooltip
 *  [tooltipText]="'Your tooltip text here'"
 * >'
 */
@Directive({
  selector: '[wfsTooltip]',
  hostDirectives: [MatTooltip]
})
export class TooltipDirective {
  #matTooltip = inject(MatTooltip);
  tooltipText = input<string | undefined>(undefined);
  tooltipDisabled = input<boolean>(false);
  tooltipPosition = input<'above' | 'below' | 'left' | 'right'>('above');
  tooltipShowDelay = input<number>(100);
  tooltipHideDelay = input<number>(100);
  tooltipClass = input<string | undefined>(undefined); // Optional class for custom styling. Make new class in material-tooltip-override.scss

  #tooltipClassComputed = computed(() => `mat-tooltip ${this.tooltipClass()}`);

  constructor() {
    effect(() => {
      this.#matTooltip.message = this.tooltipText() ?? '';
      this.#matTooltip.disabled = this.tooltipDisabled();
      this.#matTooltip.position = this.tooltipPosition();
      this.#matTooltip.showDelay = this.tooltipShowDelay();
      this.#matTooltip.hideDelay = this.tooltipHideDelay();
      this.#matTooltip.tooltipClass = this.#tooltipClassComputed();
    });
  }
}
